<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">Payroll</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row class="justify-center py-5">
                    <v-col cols="8">
                        <v-text-field
                            placeholder="Search"
                            type="text"
                            required
                            number
                            :rules="numberRule"
                            v-model="$store.state.payroll.searchInv"
                            @keydown="alert = false"
                            v-on:keyup.enter="searchPayroll()"
                        ></v-text-field>
                        <v-alert :value="alert" type="warning">
                            {{ alertMsg }}
                        </v-alert>
                    </v-col>
                </v-row>
                <v-divider></v-divider>

                <v-form ref="form" lazy-validation>
                    <v-row class="justify-center mt-8 mb-8">
                        <v-col cols="9" md="10" sm="">
                            <v-container grid-list-xs fluid>
                                <v-card>
                                    <v-toolbar dark color="primary" dense>
                                        <v-spacer></v-spacer>
                                        <v-toolbar-title class="white--text"
                                            >Create</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-btn icon @click="toggle = !toggle"
                                            ><v-icon
                                                >mdi-swap-horizontal-hidden</v-icon
                                            ></v-btn
                                        >
                                    </v-toolbar>
                                    <v-row>
                                        <v-combobox
                                            v-model="PayType"
                                            :items="PayrollType"
                                            required
                                            :rules="[
                                                v => !!v || 'Type is required'
                                            ]"
                                            :item-text="'PayTypeName'"
                                            :item-value="'PayStTypeID'"
                                            class="mx-10 mt-6"
                                            auto-select-first
                                            label="Select Statement Type"
                                        ></v-combobox>
                                        <v-text-field
                                            id="PayDate"
                                            required
                                            label="Pay Date"
                                            type="tel"
                                            :value="invoiceData.StartDate"
                                            :placeholder="
                                                $store.state.placeholder
                                            "
                                            v-mask="$store.state.mask"
                                            :rules="$store.state.dateRules"
                                            class="mx-10 mt-6"
                                        ></v-text-field>
                                    </v-row>
                                    <v-row>
                                        <v-text-field
                                            label="Start Date"
                                            required
                                            type="tel"
                                            class="mx-10"
                                            id="StartDate"
                                            :value="invoiceData.StartDate"
                                            :placeholder="
                                                $store.state.placeholder
                                            "
                                            v-mask="$store.state.mask"
                                            :rules="$store.state.dateRules"
                                        ></v-text-field>

                                        <v-text-field
                                            label="End Date"
                                            type="tel"
                                            class="mx-10"
                                            id="EndDate"
                                            :value="invoiceData.EndDate"
                                            :placeholder="
                                                $store.state.placeholder
                                            "
                                            v-mask="$store.state.mask"
                                            :rules="$store.state.dateRules"
                                        ></v-text-field>
                                    </v-row>
                                    <v-row>
                                        <v-combobox
                                            v-if="toggle"
                                            v-model="truck"
                                            :items="trucks"
                                            required
                                            :rules="[
                                                v => !!v || 'Truck is required'
                                            ]"
                                            :item-text="'Truck'"
                                            :item-value="'TruckID'"
                                            class="mx-10 mt-6"
                                            auto-select-first
                                            label="Select a Truck"
                                            dense
                                        ></v-combobox>
                                        <v-text-field
                                            label="Fuel Surcharge"
                                            type="text"
                                            v-model="fuel_surch"
                                            class="mx-10"
                                        ></v-text-field>
                                    </v-row>
                                    <v-row class="justify-end">
                                        <v-btn
                                            color="success"
                                            class="mx-10 ma-6"
                                            dark
                                            dense
                                            @click="totalStatementByRange"
                                        >
                                            <v-icon class="mr-2"
                                                >mdi-printer</v-icon
                                            >
                                            Print By Date Range
                                        </v-btn>
                                        <v-btn
                                            dark
                                            color="red"
                                            v-if="!toggle"
                                            @click="confirmDelete"
                                            class="mx-10 ma-6"
                                            dense
                                            >Delete Multi Statements</v-btn
                                        >
                                        <v-btn
                                            color="primary"
                                            @click="validate()"
                                            class="mx-10 ma-6"
                                            dense
                                            >Create and View Pay St</v-btn
                                        >
                                    </v-row>
                                </v-card>
                            </v-container>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
            <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
            <multi_statement
                v-if="dlgMultStatement"
                :dlgMultStatement="dlgMultStatement"
                :statements="statements"
                @close="dlgMultStatement = false"
            ></multi_statement>
        </v-card>
    </v-container>
</template>
<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';
import multi_statement from './../Modals/Administration/Payroll/MultiStatments.vue';

export default {
    directives: { mask },
    components: {
        ConfirmDialogue,
        multi_statement
    },
    data: () => ({
        numberRule: [
            v => (!isNaN(parseFloat(v)) && v >= 0) || 'Only numbers are allowed'
        ],
        statements: [],
        dlgMultStatement: false,
        start_date: '',
        end_date: '',
        pay_date: '',
        truck: '',
        fuel_surch: '',
        alert: false,
        trucks: [],
        alertMsg: '',
        valid: true,
        PayType: [],
        PayrollType: [
            {
                PayStTypeID: 1,
                PayTypeName: 'Regular Stmt'
            },
            {
                PayStTypeID: 2,
                PayTypeName: 'Demurrage Stmt'
            },
            {
                PayStTypeID: 3,
                PayTypeName: 'Bonus Hours Stmt'
            },
            {
                PayStTypeID: 4,
                PayTypeName: 'Credit & Debit Stmt'
            }
        ],
        invoiceData: {
            InvDate: '',
            StartDate: '',
            EndDate: '',
            customer: '',
            FSC: ''
        },
        toggle: true,
        dateRules: [
            v => !!v || 'This date is required',
            v =>
                (parseInt(v[0] + v[1]) <= 12 && parseInt(v[0] + v[1]) > 0) ||
                'Date Incorrect',
            v =>
                (parseInt(v[3] + v[4]) <= 31 && parseInt(v[3] + v[4]) > 0) ||
                'Date Incorrect'
        ]
    }),
    mounted() {
        this.loadTrucks();
    },
    methods: {
        async confirmDelete() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete multiple statements',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch

            if (ok) {
                var params = {
                    PayDate: this.$store.state.getMsk('PayDate'),
                    PayStTypeID: this.PayType['PayStTypeID']
                };
                if (
                    params.PayDate == null ||
                    params.PayDate == '' ||
                    params.PayStTypeID == null
                ) {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Statement Type & Pay Date is required'
                    });
                } else {
                    this.deleteMultiPayroll(params);
                }
            }
        },
        createPayroll: function() {
            var params = {
                PayDate: this.$store.state.getMsk('PayDate'),
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                FSC: this.fuel_surch,
                PayStTypeID: this.PayType['PayStTypeID']
            };
            console.log(params);
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('payroll/create', params, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Payroll Created.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error.response.data);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 404) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'No transactions were found during this period'
                        });
                    }
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Fsc not found'
                        });
                    }
                    if (error.response.status === 406) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'This process is only applicable to regular invoices'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    str.state.isLoading = false;
                });
        },
        deleteMultiPayroll: function(params) {
            console.log(params);
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('payroll/delete/multiple/stmt', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'sucess',
                        text: 'Statement deleted successfully'
                    });
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error.response.data);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 404) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'No transactions were found during this period'
                        });
                    }
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Fsc not found'
                        });
                    }
                    if (error.response.status === 406) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'This process is only applicable to regular invoices'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    str.state.isLoading = false;
                });
        },
        createPayrollByTruck: function() {
            var params = {
                PayDate: this.$store.state.getMsk('PayDate'),
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                FSC: this.fuel_surch,
                PayStTypeID: this.PayType['PayStTypeID'],
                Truck: this.truck['TruckID']
            };
            console.log(params);
            axios
                .post('payroll/create/by/truck', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    console.log(response.data.PayStId);
                    this.$store.state.payroll.searchInv = response.data.PayStId;
                    this.$router.push('/administration/payroll-view');
                })
                .catch(function(error) {
                    console.log(error.response.data);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 404) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'No transactions were found during this period'
                        });
                    }
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Fsc not found'
                        });
                    }
                    if (error.response.status === 406) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'This process is only applicable to regular invoices'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    str.state.isLoading = false;
                });
        },
        searchPayroll: async function() {
            this.$store.state.isLoading = true;
            if (this.$store.state.payroll.searchInv == '') {
                this.alert = true;
                this.alertMsg = 'Payroll number needed';
                this.$store.state.isLoading = false;
            } else {
                this.$store.state.payroll.dialog = true;
                try {
                    let response = await axios.get(
                        'payroll/' + this.$store.state.payroll.searchInv,
                        {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    );
                    console.log(response);
                    if (response.data.data == '') {
                        this.$store.state.payroll.dialog = false;
                        this.alert = true;
                        this.alertMsg = 'Payroll not found';
                        this.searchInv = '';
                    } else {
                        console.log('in else');
                        this.$store.state.payroll.dialog = false;
                        this.$router.push('/administration/payroll-view');
                    }
                } catch (error) {
                    if (error.response.status === 404) {
                        this.$store.state.payroll.dialog = false;
                        this.alert = true;
                        this.alertMsg = 'Payroll not found';
                        this.searchInv = '';
                    }
                }
                this.$store.state.isLoading = false;
            }
        },
        loadTrucks: function() {
            axios
                .get('truck/active')
                .then(response => {
                    this.trucks = response.data;
                    console.log(this.trucks);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                if (this.toggle) {
                    this.createPayrollByTruck();
                } else {
                    this.createPayroll();
                }
            }
        },
        totalStatementByRange: function() {
            // /
            var params = {
                PayDate: this.$store.state.getMsk('PayDate')
            };
            console.log(params);
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('payroll/total/statements', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.statements = response.data;
                    this.dlgMultStatement = true;
                    str.state.isLoading = false;
                    // const url = window.URL.createObjectURL(
                    //     new Blob([response.data])
                    // );
                    // const link = document.createElement('a');
                    // link.href = url;
                    // link.setAttribute('download', 'Payroll Created.xlsx');
                    // document.body.appendChild(link);
                    // link.click();
                    // str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error.response.data);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    str.state.isLoading = false;
                });
        }
    }
};
</script>
<style scoped>
.dmiTable td {
    border-left: 1px solid #fff;
    background: #ddd;
}

.dmiRow {
    background: #ebf3fd;
}
</style>
